module.exports = __webpack_public_path__ + "static/media/carousel17.fd9aa298.jpg";